// Shared body map types — used by HumanBodySvg, BodyTagDrawer, BodyModelLegend, and PatientAnalysisTypes

export type FrontBodyRegion =
	| 'head' | 'face' | 'neck' | 'throat'
	| 'chest_left' | 'chest_right' | 'heart' | 'lung_left' | 'lung_right'
	| 'breast_left' | 'breast_right'
	| 'abdomen_upper' | 'abdomen_lower' | 'liver' | 'stomach' | 'intestines' | 'colon' | 'bladder'
	| 'pelvis' | 'groin_left' | 'groin_right'
	| 'shoulder_left' | 'shoulder_right'
	| 'arm_upper_left' | 'arm_upper_right'
	| 'arm_lower_left' | 'arm_lower_right'
	| 'hand_left' | 'hand_right'
	| 'hip_left' | 'hip_right'
	| 'leg_upper_left' | 'leg_upper_right'
	| 'leg_lower_left' | 'leg_lower_right'
	| 'knee_left' | 'knee_right'
	| 'ankle_left' | 'ankle_right'
	| 'foot_left' | 'foot_right';

export type BackBodyRegion =
	| 'head_back' | 'neck_back'
	| 'shoulder_back_left' | 'shoulder_back_right'
	| 'upper_back' | 'mid_back' | 'lower_back' | 'spine'
	| 'kidney_left' | 'kidney_right'
	| 'glute_left' | 'glute_right'
	| 'leg_upper_back_left' | 'leg_upper_back_right'
	| 'leg_lower_back_left' | 'leg_lower_back_right'
	| 'foot_back_left' | 'foot_back_right';

export type BodyRegion = FrontBodyRegion | BackBodyRegion;

export type TagCategory = 'blood' | 'genetic' | 'history' | 'medication' | 'imaging' | 'forms';
export type TagSeverity = 'critical' | 'warning' | 'normal';

export const TAG_SEVERITY_COLORS: Record<TagSeverity, string> = {
	critical: '#ff4d4f',
	warning:  '#fa8c16',
	normal:   '#52c41a',
};

export const TAG_CATEGORY_LABELS: Record<TagCategory, string> = {
	blood:      'Blood Test',
	genetic:    'Genetic',
	history:    'Medical History',
	medication: 'Medication',
	imaging:    'Imaging',
	forms:      'Form Data',
};

export interface BodyTagEvidence {
	genes?: string[];
	lab_values?: Array<{
		name: string;
		value: string;
		range: string;
		status: 'normal' | 'borderline' | 'abnormal' | 'critical';
	}>;
	conditions?: string[];
	medications?: string[];
}

export type BodyTagOrigin = 'ai' | 'practitioner';
export type BodyTagLinkedRecordType = 'medical_history' | 'test_order';

export interface BodyTagLinkedRecord {
	type: BodyTagLinkedRecordType;
	id: number;
}

export interface BodyTag {
	// id / origin / linked_record are server-stamped at persist time — absent on
	// AI-generated tags the model returns, present on everything the API serves back.
	id?: string;
	origin?: BodyTagOrigin;
	linked_record?: BodyTagLinkedRecord;
	region: BodyRegion;
	category: TagCategory;
	severity: TagSeverity;
	title: string;
	detail: string;
	source?: string;
	evidence?: BodyTagEvidence;
}

export interface OverallSummary {
	narrative: string;
	health_score_rationale?: string;
}

